import { render } from "./OrdrePage.vue?vue&type=template&id=99413dd8"
import script from "./OrdrePage.vue?vue&type=script&lang=js"
export * from "./OrdrePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__